import { render, staticRenderFns } from "./colleges.vue?vue&type=template&id=453207ea&"
import script from "./colleges.vue?vue&type=script&lang=js&"
export * from "./colleges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports